// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__fMh0O","label":"Input_label__E9d5O","input":"Input_input__65TkF","inputError":"Input_inputError__rh4Dg","inputCompact":"Input_inputCompact__vzzNR"};